import { useEffect, useState } from "react";
import { Column } from "../../../../core/components/Column";
import { urlBackend } from "../../../../core/constants/utils";
import { RenderTop } from "../../../home/presentation/components/RenderTop";
import { useInputHandler } from "../../../../core/hooks/useInputHandler";
import { ConfigLottery } from "../components/ConfigLottery";
import { GeneralDetail } from "../components/GeneralDetail";
import { DateTime } from "../components/DateTime";
import { Publish } from "../components/Publish";
import { useNavigate } from "react-router-dom";
export const CreateLottery: React.FC = () => {
	const {
		title,
		setTitle,
		description,
		setDescription,
		date,
		setDate,
		hour,
		setHour,
		valueInputParticipant,
		valueInputPrize,
		listParticipant,
		setListParticipant,
		listPrizes,
		setListPrizes,
		handleInputChange,
		handleKeyDown,
		setValueInputPrize,
		setValueInputParticipant,
		setInputError,
	} = useInputHandler();
	const [step, setStep] = useState(1);
	const [timezone, setTimezone] = useState("");
	const [isOnly, setIsOnly] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();

	const createLottery = async () => {
		if ((listParticipant.length === 0 || listPrizes.length === 0 || title === "", date === "", hour === "")) {
			setInputError({
				title: title === "",
				date: date === "",
				hour: hour === "",
				participant: listParticipant.length === 0,
				prize: listPrizes.length === 0,
			});
			return;
		}
		setIsLoading(true);
		const eventData = {
			title,
			description,
			participants: listParticipant,
			prizes: listPrizes,
			date,
			hour,
			timezone,
			oneForOne: isOnly,
		};

		try {
			const response = await fetch(`${urlBackend}event`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(eventData),
			});

			const data = await response.json();

			if (response.ok) {
				console.log("Evento creado exitosamente:", data.eventId);
				navigate(`/lottery/${data.eventId}/success`);
			} else {
				alert(`Error al crear evento: ${data.error}`);
			}
		} catch (error) {
			alert(`Error al crear evento: ${error}`);
			console.error("Error en la solicitud:", error);
		}
		setIsLoading(false);
	};

	const handleCheckboxEquitativeChange = (newSelectedValues: string[]) => {
		setIsOnly(newSelectedValues.length > 0 ? true : false);
	};

	useEffect(() => {
		const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		setTimezone(userTimezone);
	}, []);

	const nextStep = () => setStep((prevStep) => prevStep + 1);
	const backStep = () => setStep((prevStep) => prevStep - 1);

	return (
		<Column className="py-5 px-5 gap-3 md:gap-4">
			{step === 1 && (
				<RenderTop
					handleCheckboxEquitativeChange={handleCheckboxEquitativeChange}
					isOnly={isOnly}
				/>
			)}
			{step === 1 && (
				<ConfigLottery
					next={nextStep}
					valueInputParticipant={valueInputParticipant}
					valueInputPrize={valueInputPrize}
					listParticipant={listParticipant}
					listPrizes={listPrizes}
					setListParticipant={setListParticipant}
					setListPrizes={setListPrizes}
					handleInputChange={handleInputChange}
					setValueInputPrize={setValueInputPrize}
					setValueInputParticipant={setValueInputParticipant}
					handleKeyDown={handleKeyDown}
				/>
			)}
			{step === 2 && (
				<GeneralDetail
					title={title}
					back={backStep}
					setTitle={setTitle}
					description={description}
					setDescription={setDescription}
					next={nextStep}
				/>
			)}
			{step === 3 && (
				<DateTime
					date={date}
					setDate={setDate}
					back={backStep}
					hour={hour}
					setHour={setHour}
					next={nextStep}
				/>
			)}
			{step === 4 && (
				<Publish
					loading={isLoading}
					title={title}
					description={description}
					listParticipant={listParticipant}
					listPrizes={listPrizes}
					date={date}
					back={backStep}
					hour={hour}
					createLottery={createLottery}
				/>
			)}
		</Column>
	);
};
